import React from "react";

import "./Literature.css";

const LiteratureHeader = () => {
  return (
    <section className="lit-header-wrapper" id="lit-header">
      <div className="main-padding">
        <div class="main-margin">
          <h1 className=" text-white ml-[-10px] md:ml-0 text-4xl md:text-[42px] font-semibold">
            Literature
          </h1>
        </div>
      </div>
    </section>
  );
};

export default LiteratureHeader;
